module.exports = __webpack_public_path__ + "static/media/smallGrid.bbe46ad9.png";